<div class="company-badge-component">
  <!-- Toggle Button with Company Badge -->
  <div
    class="company-badge"
    [ngClass]="{ 'dropdown-item-badge': isDropDownItem }"
    [suiTooltip]="companyName"
    suiTooltipPlacement="end"
    [suiTooltipContainer]="'auto'"
  >
    {{ initials }}
  </div>
</div>
